const Genesis = require("../Genesis.js")
import { post } from "jquery";
import { Modal } from "bootstrap";
import { PreLoadHelper } from '../Helpers/helpers';
import { WorkflowHandler } from '../Workflow/WorkflowHandler';
import flatpickr from "flatpickr";
const confirmDatePlugIn = require("flatpickr/dist/plugins/confirmDate/confirmDate");
import { BlockPageHelper } from '../Helpers/helpers';
const { PropertyAutoComplete, PopulateLocationDropdown } = require("./summary.js");
import { LazyLoadComponent } from '../Shared/LazyLoad/LazyLoadComponent';
import { FieldProcessor, FilterDataManagerComponent } from '../Shared/FilterDataManager/FilterDataManagerComponent';

export class ISiteMobileSummaryIndexPage {
    private lazyLoadComponent: LazyLoadComponent = new LazyLoadComponent({
        ListContainer: 'summaryItems',
        LoadingStatus: 'Loading-Status',
        BtnLoadMore: 'btnLoadMore',
        RequestUrl: Genesis.url('/Summary/LoadSummaryItems'),
        FilterForm: "FilterForm",
        DateFilterCol: "FilterFromDate,FilterToDate",
        HttpMethod: "POST",
        ScrollTopBtn: "scrollTopBtn",
        ScrollBottomBtn: "scrollBottomBtn"
    });
    private filterDataManager: FilterDataManagerComponent;
    constructor() {
        var propertyId = '-1';
        var locationId = '-1';
        var typeId = '-1';
        var statusId = '-1';
        const fieldProcessor: FieldProcessor = (fieldName, fieldValue) => {
            if (fieldName == "PropertyId") {
                propertyId = fieldValue
            }
            if (fieldName == "LocationId") {
                locationId = fieldValue
            }
            if (fieldName == "TypeID") {
                typeId = fieldValue
            }
            if (fieldName == "Status") {
                statusId = fieldValue
            }
            if (propertyId !== '-1' && fieldName == "LocationId") {
                PopulateLocationDropdown(propertyId, locationId);
            }
            if (typeId !== '-1' && fieldName == "Status") {
                this.LoadStatus(typeId, statusId);
            }
        };
        this.filterDataManager = new FilterDataManagerComponent('FilterForm', fieldProcessor);

        $(() => {
            this.LoadDateFields();
        });
    }
    private modal: Modal | null = null;
    private ReturnWorkOrderAction: string = "Return Work Order";
    private ApproveWorkAction: string = "Approve Work";

    public Init() {
        PropertyAutoComplete();
        
        const currentPriorityValue = $("#PriorityID").val();
        if (currentPriorityValue === '0' || currentPriorityValue === 0) {
            localStorage.removeItem('FilterForm');
        }
        
        this.filterDataManager.loadRetainedFilter();

        const srv = this;
        $('#summaryIndex .wf-btn-return').each(function () {
            $(this).click((event) => srv.ShowReturnModal(event, $(this).data("id")));
        });

        $('#summaryIndex .wf-btn-approve').each(function () {
            $(this).click((event) => srv.ShowApproveModal(event, $(this).data("id")));
        });

        $('#summaryIndex .wf-btn-view').each(function () {
            $(this).click(() => srv.ViewWorkOrder($(this).data("id"), $(this).data("type")));
        });

        $('.property-hazard-detail').each(function () {
            $(this).click(() => srv.ShowPropertyHazard($(this).data("propertyid"), $(this).data("locationid")));
        });

        this.LoadDateFields();

        $("#searchFilterButton").click(function () {
            srv.lazyLoadComponent.resetPageCount();
            srv.filterDataManager.saveFormData();
            srv.lazyLoadComponent.loadItems();
        });

        $("#resetFilterButton").click(function () {
            localStorage.removeItem('Summary_Filter');
            localStorage.removeItem('FilterForm');  // Also clear FilterForm
            $("#PropertyId").val('');
            $("#propertySearch").val('');
            $("#RelatedPropertyName").text('');
            $("#PriorityID").val('0');
            $("#TypeID").val('0');
            $("#FilterFromDate").val('');
            $("#FilterToDate").val('');
            $("#locationsDropdown").val('0');
            $("#Status").val('');
            $("#WorkOrderNo").val('');
            srv.lazyLoadComponent.resetPageCount();
            srv.lazyLoadComponent.loadItems();
        });

        $("#TypeID").change(function () {
            const typeId = $("#TypeID").val() as string | undefined; 
            const statusId = $("#Status").val() as string; 
            if (typeId) { 
                srv.LoadStatus(typeId, statusId);
            }
        });
    }

    public LoadStatus(typeId: string, statusId: string) {
        post({
            url: Genesis.url('/Summary/GetStatus'),
            data:
            {
                typeId: typeId,
            }
        }).then((result) => {
            var s = '<option value="">Select Status (if required)</option>';
            for (var i = 0; i < result.length; i++) {
                s += '<option value="' + result[i].systemCode + '">' + result[i].name + '</option>';
            }
            $("#Status").html(s);
            if (statusId != "-1" && statusId != "undefined") {
                $('#Status option[value="' + statusId + '"]').attr("selected", "selected");
            }
        });
    }

    public LoadDateFields() {
        const dateConfig: any = {
            dateFormat: "d/m/Y",
            enableTime: false,
            time_24hr: false,
            "plugins": [confirmDatePlugIn({
                confirmIcon: "<i class='fa fa-check'></i>",
                confirmText: "OK ",
                showAlways: true,
                theme: "dark"
            })]
        };
        flatpickr("#FilterFromDate", dateConfig);
        flatpickr("#FilterToDate", dateConfig);
    }

    private ShowReturnModal(event: any, id: number) {
        WorkflowHandler.handleActionButton(event, id, this.ReturnWorkOrderAction, false);
    }

    private ShowApproveModal(event: any, id: number) {
        WorkflowHandler.handleActionButton(event, id, this.ApproveWorkAction, false);
    }

    private ViewWorkOrder(id: string, type: string) {
        BlockPageHelper.block();
        if (type === "W") {
            self.location.href = Genesis.url('/WorkOrder/View?id=' + id);
        } else if (type === "P") {
            self.location.href = Genesis.url('/WorkOrder/PPMJobScreen?id=' + id);
        }
    }

    private ShowPropertyHazard(propertyId: number, locationId: number) {
        post({
            url: Genesis.url('/WorkOrder/GetPropertyHazards'),
            data:
            {
                propertyId: propertyId,
                locationId: locationId
            }
        }).then((result) => {
            const propertyhazardModal = document.getElementById('propertyHazardModal');
            if (propertyhazardModal != null) {
                $("#propertyhazard-content").html(result);
                $("#hazardLocation").append($("#" + propertyId + "_" + locationId).html());
                this.modal = new Modal(propertyhazardModal, { backdrop: 'static', keyboard: false });
                this.modal.show();
            }
        });
    }

}